module.exports = __webpack_public_path__ + "static/media/icono-apps.870fd7b5.png";